const CustomDurationColumn: React.FC<any> = (props) => {
    const { startDate, duration } = props.data;

    const [hours, minutes, seconds] = startDate.split(":").map(Number);
    const now = new Date();
    const startTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes,
        seconds
    );

    const endTime = new Date(startTime.getTime() + duration * 60000); // duration is in minutes

    const formatTime = (date: Date) => {
        return date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    };

    return (
        <div className="duration-column">
            {props.startOnly
                ? formatTime(startTime)
                : formatTime(startTime) + " - " + formatTime(endTime)}
            {/* {formatTime(startTime)} - {formatTime(endTime)} */}
        </div>
    );
};

export default CustomDurationColumn;
